var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6599 20.3305C10.4891 20.3305 10.3396 20.2664 10.2114 20.1383C10.0833 20.0101 10.0192 19.8607 10.0192 19.6898V10.6562L2.23492 4.18526C2.12814 4.09984 2.05339 3.99306 2.01068 3.86492C1.98932 3.71543 2 3.57662 2.04271 3.44848C2.08542 3.32034 2.16017 3.21356 2.26695 3.12814C2.37373 3.04271 2.50187 3 2.65136 3H21.3593C21.5088 3 21.6369 3.04271 21.7437 3.12814C21.8505 3.21356 21.9253 3.32034 21.968 3.44848C22.0107 3.57662 22.0107 3.71543 21.968 3.86492C21.9466 3.99306 21.8825 4.09984 21.7758 4.18526L14.0235 10.6562V17.6716C14.0235 17.9066 13.9274 18.0881 13.7352 18.2162L11.0763 20.2023C10.9482 20.2878 10.8094 20.3305 10.6599 20.3305ZM4.50934 4.3134L11.1084 9.82328C11.2579 9.95142 11.3326 10.1223 11.3326 10.3358V18.3444L12.6781 17.3513V10.3358C12.6781 10.1223 12.7528 9.95142 12.9023 9.82328L19.5013 4.3134H4.50934Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.571259ae09f052b5669f30728fe68412.svg";
export { ForwardRef as ReactComponent };